import { constructDate } from "../models/Periods";
export const findNodes = (node, key) => {
    return node?.filter((node) => Object.keys(node ?? {})[0] === key).map(v => v?.[key]) ?? [];
};
export const findNode = (node, key) => {
    return findNodes(node, key)[0];
};
export const getChild = (node, key) => findNode(node, key)?.children ?? [];
export const getChilds = (node, key) => findNodes(node, key).map(v => v.children);
export const convertDateToStructured = (invoiceDate) => {
    if (!invoiceDate) {
        return { year: undefined, period: undefined, day: undefined, date: undefined, raw: undefined };
    }
    const invoiceDateParsed = {
        year: Number(invoiceDate.substring(0, 4)),
        period: Number(invoiceDate.substring(4, 6)),
        day: Number(invoiceDate.substring(6, 8)),
    };
    const date = constructDate(invoiceDateParsed.year, invoiceDateParsed.period, invoiceDateParsed.day);
    return { ...invoiceDateParsed, date, raw: invoiceDate };
};
export function convert102Date(v) {
    if (!v) {
        return undefined;
    }
    return `${v.substring(6, 8)}.${v.substring(4, 6)}.${v.substring(0, 4)}`;
}
//# sourceMappingURL=CIITools.js.map